import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IDeclineErrors, IDeclineParams } from './decline.types';

const PREFIX = 'RECIPIENT/DECLINE';

export const declineGiftRequest = createAction<IDeclineParams>(`${PREFIX}/DECLINE_GIFT_REQUEST`);
export const declineGiftSuccess = createAction<void>(`${PREFIX}/DECLINE_GIFT_SUCCESS`);
export const declineGiftFail = createAction<TLegacyErrors<IDeclineErrors>>(`${PREFIX}/DECLINE_GIFT_FAIL`);
export const resetErrors = createAction<void>(`${PREFIX}/RESET_ERRORS`);
